import styled from 'styled-components';

export const ResendTimeoutWrapper = styled.div`
  display: flex;
  gap: 10px;
`;

export const SecondsLeftWrapper = styled.span`
  white-space: nowrap;
  display: inline-block;
  min-width: 90px; /* Helps prevent line jumping */
`;
